import hyRequest from '@/service'
import { parseStrEmpty } from "@/utils/ruoyi";
import { IDataType } from '@/service/types'

// 查询用户列表
export function listUser(query: any) {
  return hyRequest.get<IDataType>({
    url: '/system/user/list',
    params: query
  })
}

// 查询用户详细
export function getUser(userId: string | number) {
  return hyRequest.get<IDataType>({
    url: '/system/user/' + parseStrEmpty(String(userId))
  })
}

// 新增用户
export function addUser(data: any) {
  return hyRequest.post<IDataType>({
    url: '/system/user',
    data
  })
}

// 修改用户
export function updateUser(data: any) {
  return hyRequest.put<IDataType>({
    url: '/system/user',
    data
  })
}

// 删除用户
export function delUser(userId: string | number) {
  return hyRequest.delete<IDataType>({
    url: '/system/user/' + userId
  })
}

// 用户密码重置
export function resetUserPwd(userId: string | number, password: string) {
  const data = {
    userId,
    password
  }
  return hyRequest.put<IDataType>({
    url: '/system/user/resetPwd',
    data
  })
}

// 用户状态修改
export function changeUserStatus(userId: string | number, status: string | number) {
  const data = {
    userId,
    status
  }
  return hyRequest.put<IDataType>({
    url: '/system/user/changeStatus',
    data
  })
}

// 查询用户个人信息
export function getUserProfile() {
  return hyRequest.get<IDataType>({
    url: '/system/user/profile'
  })
}

// 修改用户个人信息
export function updateUserProfile(data: any) {
  return hyRequest.put<IDataType>({
    url: '/system/user/profile',
    data
  })
}

// 用户密码重置
export function updateUserPwd(oldPassword: string, newPassword: string) {
  const data = {
    oldPassword,
    newPassword
  }
  return hyRequest.put<IDataType>({
    url: '/system/user/profile/updatePwd',
    params: data
  })
}

// 用户头像上传
export function uploadAvatar(data: any) {
  return hyRequest.post<IDataType>({
    url: '/system/user/profile/avatar',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data
  })
}

// 查询授权角色
export function getAuthRole(userId: string | number) {
  return hyRequest.get<IDataType>({
    url: '/system/user/authRole/' + userId
  })
}

// 保存授权角色
export function updateAuthRole(data: any) {
  return hyRequest.put<IDataType>({
    url: '/system/user/authRole',
    params: data
  })
}

// 查询部门下拉树结构
export function deptTreeSelect() {
  return hyRequest.get<IDataType>({
    url: '/system/user/deptTree'
  })
}

export function submit(data: any) {
  return hyRequest.post<IDataType>({
    url: '/app/order/submit',
    data
  })
} 